import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component({})
export default class ChoiceResult extends Vue {
    @Prop() private exam: any;
    @Prop() private examDetail: any;
    private userAvatar: string = "";
    mounted() {
        this.userAvatar = JSON.parse(localStorage.getItem("user")).avatar;
    }
    closeScore(examDetailData) {
        this.$set(examDetailData, "showScore", false);
        if (examDetailData.examPass) {
            //查看答案
            this.handleShowAnswer(examDetailData, true);
        } else {
            //查看提示
            this.handleShowAnswer(examDetailData, false);
        }
    }
    @Emit()
    handleExamRefresh() {}

    @Emit()
    nextSectionClick() {}

    handleShowAnswer(examDetailData, val) {
        this.$set(examDetailData, "isAnsweringQuestion", false);
        this.$set(examDetailData, "examPass", val);
        this.$set(examDetailData, "showScore", false);
    }
}

//@ts-ignore
export { default as ChoiceResult } from "./index.vue";
